var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "address", attrs: { title: _vm.display } }, [
    _vm.showGoogleMapLink
      ? _c(
          "a",
          {
            attrs: {
              id: "googleMapLink",
              href: `https://www.google.com/maps/search/?api=1&query=${_vm.display}`,
              target: "_blank",
            },
          },
          [_c("i", { class: _vm.icon_class })]
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", {
      staticClass: "address-display",
      domProps: { innerHTML: _vm._s(_vm.display) },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }